export default __webpack_public_path__ + "static/media/NotoSansKR-Bold.41a2d87a.ttf";